import { render } from "./ContentAnnotation.vue?vue&type=template&id=e3670c62&scoped=true&ts=true"
import script from "./ContentAnnotation.vue?vue&type=script&lang=ts"
export * from "./ContentAnnotation.vue?vue&type=script&lang=ts"

import "./ContentAnnotation.vue?vue&type=style&index=0&id=e3670c62&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3670c62"]])

export default __exports__